<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>حركة الموردين</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع حركة الموردين
                                <div class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-12' style="margin:0px 0px 10px 0px;padding:0px">
                                <div class='col-lg-5 col-md-5 col-sm-5'>
                                      <label>المورد</label>
                                      <select class="form-control" v-model= 'vendor_id'>
                                        <option v-for="item in vendors" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                </div>

                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                                </div>
                                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> عرض </b>
                                        </button>
                                    </div>
                              </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>المورد</th>
                                          <th style='text-align: center'>المبلغ</th>
                                          <th style='text-align: center'>الخزنة</th>
                                          <th style='text-align: center'>ملاحظات</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.vendor_name}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.treasury_name}}</td>
                                          <td align='center'>{{record.notes}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='form-group col-lg-4 col-md-4 col-sm-12'>
                               <label>الفرع:</label>
                               <select @change='changeBranche()' class="form-control" style="padding: 0px" v-model="branch_id">
                                 <option v-for="branch in branches" v-bind:key="branch.id" v-bind:value="branch.id">
                                   {{ branch.name }}
                                 </option>
                               </select>
                             </div>
                             <div class='form-group col-lg-4 col-sm-4'>
                               <label>الخزنة:</label>
                               <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                                 <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                                   {{ treasury.name }}
                                 </option>
                               </select>
                             </div>
                                 <div class='form-group col-lg-4 col-sm-4'>
                                         <label>المورد</label>
                                         <select class="form-control" v-model='record.vendor_id' >
                                           <option v-for="item in vendors" v-bind:key="item.id" v-bind:value="item.id">
                                             {{ item.name }}
                                           </option>
                                         </select>
                                   </div>
                                   <div class='form-group col-lg-4 col-sm-4'>
                                       <label>المبلغ:</label>
                                       <input v-model='record.amount' class='form-control' name='amount' type='text'>
                                   </div>
                                   <div class='form-group col-lg-4 col-sm-4'>
                                     <tbDate  :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
                                   </div>
                                 <div class='form-group col-lg-4 col-sm-4'>
                                     <label>ملاحظات:</label>
                                     <input v-model='record.notes' class='form-control' name='notes' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'vendors_movements',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      dateTitle: 'التاريخ',
      date_from: '',
      date_to: '',
      vendors: {},
      vendor_id: '',
      treasuries: {},
      validationErrors: '',
      mainValidationErrors: '',
      records: {},
      record: {},
      branch_id: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      emptyRec: [{id: 0, name: ''}],
      title: ''
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.changeBranche()
    this.GetVendors()
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
      }
    },
    GetVendors () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getVendors', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.vendors = data
          this.vendors.unshift(this.emptyRec)
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getVendorsMovements', {
        token: localStorage.getItem('token'),
        vendor_id: this.vendor_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
          this.mainValidationErrors = err.response.data.errors
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {
          'id': 0,
          'vendor_id': '',
          'amount': '',
          'treasury_id': '',
          'notes': '',
          'date': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveVendorsMovements', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        vendor_id: this.record.vendor_id,
        date: this.record.date,
        amount: this.record.amount,
        treasury_id: this.record.treasury_id,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteVendorsMovements', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/VendorsMovements.vue